(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDeleteController',FeeDeleteController);

    FeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fee'];

    function FeeDeleteController($uibModalInstance, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
